var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-heading"},[_c('span',{staticClass:"page-heading__en nw-pageHeadingEn"},[_vm._v(_vm._s(_vm.headingEn))]),_c('span',{staticClass:"page-heading__ja nw-pageHeadingJa"},[_vm._v(_vm._s(_vm.headingJa))])])}
var staticRenderFns = []

export { render, staticRenderFns }